module.exports = __webpack_public_path__ + "img/Martin Wiederkehrsm.e589c505.jpg";